/**
 * Created by christiancueni on 02/08/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import find from 'lodash-es/find';
import { createSelector } from "@ngrx/store";
import { GroupsActionTypes } from "../actions/groups";
import { Group, User } from "../models";
import { CustomAction } from '../actions/CustomAction';

export interface GroupState {
    groups: Group[];
    groupsForSchool: Group[];
    currentMembers: User[];
    selectedGroupId: number;
    loading: boolean;
    removeUserActionShown: boolean;
    showDeleteGroupModal: boolean;
    showRemoveUserModal: boolean;
    showDeleteUserModal: boolean;
    groupsFormErrors: Object[];
}

export const initialGroupState: GroupState = {
    groups: [],
    groupsForSchool: [],
    currentMembers: [],
    selectedGroupId: -1,
    loading: false,
    removeUserActionShown: false,
    showDeleteGroupModal: false,
    showRemoveUserModal: false,
    showDeleteUserModal: false,
    groupsFormErrors: []
};

export function reducer(state = initialGroupState, action: CustomAction): GroupState {
    switch (action.type) {
        case GroupsActionTypes.LOAD_GROUPS:
            return Object.assign({}, state, {
                loading: true,
                groups: initialGroupState.groups
            });

        case GroupsActionTypes.LOAD_GROUPS_SUCCESS:

            let selectedGroupObj = null;

            try {
                selectedGroupObj = action.payload.filter((group) => group.id === state.selectedGroupId)[ 0 ];
            } catch (error) {
            }

            return Object.assign({}, state, {
                groups: action.payload,
                loading: false,
                selectedGroup: selectedGroupObj
            });


        case GroupsActionTypes.LOAD_GROUP_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                user: action.payload,
            });

        case GroupsActionTypes.LOAD_GROUPS_FAIL:
            return initialGroupState;

        case GroupsActionTypes.LOAD_GROUPS_FOR_SCHOOL:
            return Object.assign({}, state, {
                loading: true,
                groupsForSchool: initialGroupState.groupsForSchool
            });

        case GroupsActionTypes.LOAD_GROUPS_FOR_SCHOOL_SUCCESS:
            return Object.assign({}, state, {
                groupsForSchool: action.payload,
                loading: false
            });

        case GroupsActionTypes.LOAD_GROUPS_FOR_SCHOOL_FAIL:
            return initialGroupState;

        case GroupsActionTypes.LOAD_GROUP_MEMBERS:

            let selectedGroup = null;

            // todo:potential race condition with groups. potential solution use only id
            try {
                selectedGroup = state.groups.filter((group) => group.id === +action.payload)[ 0 ];
            } catch (error) {
            }

            return Object.assign({}, state, {
                loading: true,
                currentMembers: initialGroupState.currentMembers,
                selectedGroup: selectedGroup,
                selectedGroupId: +action.payload,
            });

        case GroupsActionTypes.LOAD_GROUP_MEMBERS_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                currentMembers: action.payload
            });

        case GroupsActionTypes.LOAD_GROUP_MEMBERS_FAIL:
            return Object.assign({}, state, {
                loading: false,
                currentMembers: []
            });

        case GroupsActionTypes.ADD_GROUP:
            return Object.assign({}, state, {
                loading: true
            });

        case GroupsActionTypes.ADD_GROUP_SUCCESS:
            let groups = [ ...state.groups, action.payload ];

            return {
                groups: groups,
                groupsForSchool: groups,
                loading: false,
                currentMembers: [],
                selectedGroupId: -1,
                removeUserActionShown: false,
                showDeleteGroupModal: false,
                showRemoveUserModal: false,
                showDeleteUserModal: false,
                groupsFormErrors: []
            };

        case GroupsActionTypes.ADD_GROUP_FAIL:
            return Object.assign({}, state, {
                loading: false
            });

        case GroupsActionTypes.SET_GROUP:
            return Object.assign({}, state, {
                selectedGroupId: action.payload
            });

        case GroupsActionTypes.UNSET_GROUP:
            return Object.assign({}, state, {
                selectedGroupId: initialGroupState.selectedGroupId,
                currentMembers: []
            });

        case GroupsActionTypes.SHOW_REMOVE_USER_ACTION:
            return Object.assign({}, state, {
                removeUserActionShown: true
            });

        case GroupsActionTypes.HIDE_REMOVE_USER_ACTION:
            return Object.assign({}, state, {
                removeUserActionShown: false
            });

        case GroupsActionTypes.SHOW_REMOVE_USER_MODAL:
            return Object.assign({}, state, {
                showRemoveUserModal: true
            });

        case GroupsActionTypes.HIDE_REMOVE_USER_MODAL:
        case GroupsActionTypes.REMOVE_MEMBERS_FROM_GROUP:
            return Object.assign({}, state, {
                showRemoveUserModal: false
            });

        case GroupsActionTypes.SHOW_DELETE_USER_MODAL:
            return Object.assign({}, state, {
                showDeleteUserModal: true
            });

        case GroupsActionTypes.HIDE_DELETE_USER_MODAL:
                return Object.assign({}, state, {
                    showDeleteUserModal: false
                });

        case GroupsActionTypes.DELETE_GROUP_USER_ACTION:
            return Object.assign({}, state, {
                showDeleteGroupModal: true
            });

        case GroupsActionTypes.DELETE_GROUP_CONFIRMATION:
        case GroupsActionTypes.DELETE_GROUP_CANCEL:
            return Object.assign({}, state, {
                showDeleteGroupModal: false
            });

            case GroupsActionTypes.DELETE_GROUP_USER_ACTION:
                return Object.assign({}, state, {
                    showDeleteGroupModal: true
                });

            case GroupsActionTypes.DELETE_GROUP_CONFIRMATION:
            case GroupsActionTypes.DELETE_GROUP_CANCEL:
                return Object.assign({}, state, {
                    showDeleteGroupModal: false
                });

        case GroupsActionTypes.GROUPS_FORM_ERRORS:
            return Object.assign({}, state, {
               groupsFormErrors: action.payload
            });

        case GroupsActionTypes.RESET_GROUPS:
            return Object.assign({}, initialGroupState);

        default: {
            return state;
        }
    }
}

// getters for state members

export function getGroups(state: GroupState) {
    return state.groups;
}

export function getGroupsForSchool(state: GroupState) {
    return state.groupsForSchool;
}

export function getMembers(state: GroupState) {
    return state.currentMembers;
}

export const getSelectedGroup = createSelector(
    getSelectedGroupId,
    getGroups,
    (getSelectedGroupId: number, groups: Group[]) => find(groups, obj => obj['id'] === getSelectedGroupId)
)

export function getSelectedGroupId(state: GroupState) {
    return state.selectedGroupId;
}

export function isLoading(state: GroupState) {
    return state.loading;
}

export function getRemoveUserActionShown(state: GroupState) {
    return state.removeUserActionShown;
}

// export function getIsInitialGroupState(state$: Observable<GroupState>) {
//     // indicates whether the groups were loaded for the first time
//     return state$.select(s => s.groups)
//             .map(groups => groups.length === 0);
// }

export function getShowDeleteGroupModal(state: GroupState) {
    return state.showDeleteGroupModal;
}

export function getShowRemoveUserModal(state: GroupState) {
    return state.showRemoveUserModal;
}

export function getShowDeleteUserModal(state: GroupState) {
    return state.showDeleteUserModal;
}

export function getGroupsFormErrors(state: GroupState) {
    return state.groupsFormErrors;
}
